import { AfterViewInit, Component, Inject, Input } from '@angular/core';

import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';

import { Observable, Subject, combineLatest, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { UserService } from '../../../humain/user/services/user.service';
import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';

import { AntenneService } from '../services/antenne.service';
import { AntenneTLR } from '../entities/antenne-tlr.entity';

@Component({
	selector: 'antenne-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class AntenneCheckboxListComponent extends EntityCheckboxListComponent<AntenneTLR> implements AfterViewInit {
	_agenceId: number | null = null;
	@Input() set agenceId(id: number | null | undefined) {
		if (id != undefined && id != this._agenceId) {
			this._agenceId = id;
			this.agenceIdSubject.next(id);
		}
	}
	get agenceId(): number | null | undefined {
		return this._agenceId;
	}
	agenceIdSubject = new Subject<number | null>();
	
	// Label du champ
	@Input() override label: string | null = "Antenne(s)"
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Toutes"
	
	// Fonction determinant le label d'une antenne
	override getEntityLabel = (antenne: AntenneTLR) => antenne.nom;
	
	// Fonction determinant la couleur du label d'une antenne
	override getEntityColor = (antenne: AntenneTLR) => antenne.couleur;
	
	// Fonction determinant quelle(s) antenne(s) doivent etre preselectionnees par defaut
	override shouldBeSelectedByDefaut!: (antenne: AntenneTLR) => boolean;
	
	// Observable des antennes qu'il faut deselectionner sur commande du parent
	@Input() set antenneDeselectionRequests(obs: Observable<number>) {
		this.deselectionsSubject = obs.pipe(
			map (
				(antenneId) => (item: AntenneTLR) => item.id === antenneId
			)
		)
	}

	constructor( //
		@Inject(UserService) userService: UserService, //
		@Inject(AntenneService) private antenneService: AntenneService //
	) {
		super();
		
		let user$ = userService.getCurrentUserTLR();
		
		let userAntenne$ = user$.pipe(
			mergeMap(
				(user: UserTLR) => {
					return user.role === 'EXP' ? //
						antenneService.getAntenneTLRById(user.antenneId) //
						: //
						of(null) //
					;
				}
			)
		);
		
		let antennes$ = this.agenceIdSubject.pipe(
			mergeMap(
				(agenceId: number | null) => {
					return agenceId ? //
						this.antenneService.getAntenneTLRByAgence(agenceId) //
						: //
						this.antenneService.getAntenneTLRList() //
					;
				}
			),
			map(
				(antennes: AntenneTLR[]) => antennes.sort((a,b) => a.nom.localeCompare(b.nom) )
			)
		);
		
		// NB: il ne faut pas passer la liste des antennes au sous composant avant que l'antenne de l'utilisateur ne soit determinee
		// Sinon, le sous composant ne fera pas correctement la pre-selection des antennes.
		// Pour assurer que ce point soit respecte, on se base une combinaisons de deux observables: un pour l'agenceId et un pour la dite agence
		// 'combineLatest' a en effet pour particularite de ne pas lancer sa fonction de resultat tant que les deux observables ont au moins emis une valeur 
		combineLatest([antennes$, userAntenne$]).subscribe(
			(data) => {
				let antennes = data[0];
				let userAntenne = data[1];
				
				if (userAntenne) {
					let antenneRef = userAntenne;
					this.shouldBeSelectedByDefaut = (antenne: AntenneTLR) => antenne.agenceId != antenneRef.agenceId || antenne.id === antenneRef.id;
				} else {
					this.shouldBeSelectedByDefaut = (_antenne: AntenneTLR) => true;
				}
				
				this.entities = antennes;
			}
		)
	}

	override ngAfterViewInit() {
		// Dans le cas ou le parent ne fixe pas l'agenceId, il faut quand meme emettre un null dans l'observable pour que l'initialisation des antennes puisse se faire
		if (this._agenceId === null) {
			this.agenceIdSubject.next(null);
		}
	}
}